import React, { useState, useEffect } from "react";
import "../App.css";
import { Helmet } from "react-helmet";
import banner from "../assets/about-banner.webp"; 

const PrivacyPolicy = () => {
  return (
    <section className="privacy-page">
      <Helmet>
        <link
    rel="canonical"
    href="https://slimlinehardwarefittings.com/privacy-policy"
  />
  <title>Privacy Policy | Slimline Hardware</title>
  <meta name="description" content="Read the privacy policy of Slimline Hardware regarding data usage and protection." />
</Helmet>
      {/* ===== HERO ===== */}
      <div className="privacy-hero">
        <img src={banner} alt="Privacy Policy Banner" loading="lazy"  />
        <div className="privacy-hero-overlay">
          <h1>Privacy Policy</h1>
          <p>Your privacy matters to us</p>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <div className="privacy-container">
        <div className="privacy-grid">
          <div className="privacy-card">
            <h2>Introduction</h2>
            <p>
              We respect your privacy and are committed to protecting your
              personal information. This policy explains how we collect and use
              your data.
            </p>
          </div>

          <div className="privacy-card">
            <h2>Information We Collect</h2>
            <ul>
              <li>Name, email & contact details</li>
              <li>Information from contact forms</li>
              <li>Website usage data</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>How We Use Data</h2>
            <p>
              Your data helps us improve our services, respond to queries and
              deliver better customer experience.
            </p>
          </div>

          <div className="privacy-card">
            <h2>Security</h2>
            <p>
              We apply industry standard security practices to protect your
              personal information.
            </p>
          </div>

          <div className="privacy-card">
            <h2>Third Party</h2>
            <p>
              We do not sell or share your data with any third party except
              legal requirements.
            </p>
          </div>

          <div className="privacy-card highlight">
            <h2>Contact Us</h2>
           <p>
  For privacy related concerns, email us at{" "}
  <a href="mailto:info@slimlinekitchens.com" className="privacy-email">
    info@slimlinekitchens.com
  </a>
</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
